
import { defineComponent } from "vue";

export default defineComponent({
  name: "CiRatingSri",
  props: {
    value: { type: Number, default: 0 },
    sizeClass: { type: String, default: "xxs text-sm" },
    max: { type: Number, default: 7 },
    short: { type: Boolean, default: false },
    activeColor: { type: String, default: "primary" },
    inactiveColor: { type: String, default: "medium" },
  },
  setup(props) {
    const bubbles = new Array(props.max);
    const itemClasses = (index: number): string =>
      `${props.sizeClass} ${index + 1 === props.value ? "bg-primary text-light" : "text-dark"}`.trim();
    return {
      bubbles,
      itemClasses,
    };
  },
});
